<template>
	<v-container fluid h-100 py-1 px-3>
		<v-layout row wrap fill-height align-content-space-between py-0>
			<v-flex xs12 class="text-ai-panel__work-area pr-2">
				<v-textarea
					v-model="inputText"
					label="Input"
					outlined
					rows="6"
					:rules="[isTextValid]"
					class="pt-0 mt-0"
				/>

				<v-select v-model="selectedCommand" :items="commands" label="Select a command" outlined dense />

				<v-textarea
					v-model="reWrittenText"
					label="Output"
					outlined
					rows="6"
					:rules="[isTextValid]"
					class="pt-0 mt-0"
				/>
			</v-flex>

			<v-flex xs12 class="text-xs-center text-ai-panel__footer">
				<v-btn color="primary" @click="handleRewriteText" :disabled="!canRewriteText">Generate</v-btn>
				<v-btn color="primary" @click="handleApply" :disabled="!canApply">Apply</v-btn>

				<BerthaDisclaimer class="mt-2"></BerthaDisclaimer>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import BerthaDisclaimer from '../_components/placeholders/BerthaDisclaimer.vue';

export default {
	components: {
		BerthaDisclaimer
	},
	props: ['block', 'isAIWorking'],
	inject: ['aiService', 'lessonPlanController'],
	data() {
		return {
			commands: ['Check grammar', 'Make text more formal', 'Make text longer', 'Make text shorter'],
			maxTextLength: 9000,
			selectedCommand: '',
			reWrittenText: '',
			inputText: this.block.data.html,
			jobId: ''
		};
	},
	computed: {
		canRewriteText() {
			return this.selectedCommand !== '' && this.inputText.trim() !== '';
		},
		canApply() {
			return this.reWrittenText.trim() !== '';
		}
	},
	methods: {
		isTextValid(text) {
			const isWithinRange = text.length <= this.maxTextLength;
			if (!isWithinRange) return `Text exceeds ${this.maxTextLength} chars`;

			return true;
		},
		async reWriteText() {
			const result = await this.aiService.reWriteText(this.inputText, this.selectedCommand);

			return result;
		},
		async handleRewriteText() {
			try {
				this.$emit('update:isAIWorking', true);

				const result = await this.reWriteText();

				this.jobId = result.id;
				this.reWrittenText = result.response.rewrittenText;
			} catch (error) {
				this.lessonPlanController.showNotification(error);
			} finally {
				this.$emit('update:isAIWorking', false);
			}
		},
		handleApply() {
			this.block.data.html = this.reWrittenText;
			this.inputText = this.reWrittenText;
			this.block.data.jobId = this.jobId;
			this.reWrittenText = '';
		}
	}
};
</script>
<style scoped>
.text-ai-panel__work-area {
	max-height: 70%;
	overflow-y: scroll;
}
.text-ai-panel__footer {
	position: sticky;
	bottom: 0;
}
</style>